<twc-accordion class="twc-mt-1 twc-mb-3" [expanded]="isExpanded()">

    <twc-accordion-title>
        {{label | translate}}
        <div class="float-right">
            <twc-icon *ngIf="isRule()" shape="close" [size]="24" (click)="deleteRule($event)"
                [twcTooltip]="'VECTOR_LAYER_PROPERTIES.DELETE_RULE' | translate"></twc-icon>
            <twc-icon *ngIf="isStyle()" shape="add" [size]="24" (click)="addRule($event)"
                [twcTooltip]="'VECTOR_LAYER_PROPERTIES.NEW_RULE' | translate"></twc-icon>
        </div>
    </twc-accordion-title>

    <twc-accordion-content class="width-content">
        <cw-property-bag *ngIf="!isGeometry() && childrenFields" [propertySet]="childPropertySet"
            [catalogObject]="catalogObject" [properties]="childrenFields">
        </cw-property-bag>

        <twc-accordion *ngIf="isGeometry()" class="twc-mt-1 twc-mb-3" [expanded]="true">
            <twc-accordion-title>
                {{getGeometryName()}}
            </twc-accordion-title>

            <twc-accordion-content class="width-content">
                <cw-property-bag *ngIf="childrenFields" [propertySet]="childPropertySet" [properties]="childrenFields"
                    [catalogObject]="catalogObject">
                </cw-property-bag>
            </twc-accordion-content>
        </twc-accordion>

    </twc-accordion-content>

</twc-accordion>